"use client";

import { isOpenedFromCapacitor, navigateToTenantSelector } from "@/lib/capacitor";
import { useEffect } from "react";

/** A native account belongs to the wrapper, which restores its organization and token. */
export default function NativeLoginRedirect() {
  useEffect(() => {
    if (isOpenedFromCapacitor()) {
      navigateToTenantSelector({ resumeSession: true });
    }
  }, []);

  return null;
}
